<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  created: function() {
  },
  destroyed: function() {
  },
  computed: {
  },
}
</script>
